import Text from './Text';
import { style } from 'constant/constants';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { SYSTEM_COMPONENT_TYPES } from 'constant/enums';

const headerStyles = { fontWeight: 'bold', color: style.LIGHT.primary };

const urlForLargeIce2 = '/Components - Fence/Deck Mount/Large Ice Flags - 2 tube system.png';
const urlForSmalllIce2 = '/Components - Fence/Clamp-on/Small Ice Flags - 2 tube system.png';
const urlForLargeIce2Copper = '/Components - Fence/Deck Mount/Deck Mount Ice Flags_2Bar Copper.png';
const urlForSmallIce2Copper = '/Components - Fence/Clamp-on/Clamp-on Ice Flags 2 Bar Copper.png';

const getBracketItem = (cartData) => {
  const bracketItem = {
    iconURL: cartData?.iconUrl,
    name: cartData?.bracketType,
    type: 'Bracket',
    materialName: cartData?.bracketMaterial,
    currentTierPrice: cartData?.unitPrice,
    quantity: 1
  };
  return bracketItem;
};

/**
 *
 * @param {Object} cartData
 * @returns data in the formate that can b used in table view easily.
 */
export const getformattedCartData = (cartData) => {
  if (
    cartData?.systemComponents?.length < 1 ||
    cartData?.systemComponents?.some((comp) => isNaN(comp?.currentTierPrice))
  )
    return {
      componentsData: [],
      totalPrice: 0,
      reqObject: {}
    };
  if (cartData?.outputs?.length > 0) {
    let arryOfComps = cartData?.systemComponents || [];
    arryOfComps = [getBracketItem(cartData), ...arryOfComps];
    const quantities = {
      Bracket: cartData?.outputs[5],
      [SYSTEM_COMPONENT_TYPES.COLLAR]: cartData?.outputs[7],
      [SYSTEM_COMPONENT_TYPES.COUPLING]: cartData?.outputs[6],
      [SYSTEM_COMPONENT_TYPES.ICE_FLAG]: cartData?.outputs[8],
      [SYSTEM_COMPONENT_TYPES.PIPE]: cartData?.outputs[6],
      [SYSTEM_COMPONENT_TYPES.STOP_END]: cartData?.outputs[7]
    };
    let reqObject = {};
    let totalPrice = 0;
    arryOfComps = arryOfComps.map((item) => {
      const isUnion = item?.name?.includes('Union');
      const price = isUnion ? 0.0 : item?.currentTierPrice * Math.ceil(quantities[item?.type]);
      totalPrice += price;
      reqObject = {
        ...reqObject,
        [item?.type]: {
          ...item,
          quantity: quantities[item?.type],
          price: isUnion ? 0.0 : price
        }
      };
      return {
        ...item,
        quantity: quantities[item?.type],
        price: isUnion ? 0.0 : price
      };
    });
    return {
      componentsData: arryOfComps,
      totalPrice: totalPrice,
      reqObject: reqObject
    };
  }
};

const FenceCartContent = ({ cartData }) => {
  const [cartDataState, setCartDataState] = useState(cartData?.systemComponents || []);
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    const { componentsData, totalPrice } = getformattedCartData(cartData);
    setTotalPrice(totalPrice);
    setCartDataState(componentsData);
  }, [cartData]);
  // code
  let systemComponentsHTML = null;
  if (cartData?.outputs?.length > 0) {
    systemComponentsHTML = (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 900 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell style={headerStyles}>Name</TableCell>
              <TableCell style={headerStyles}>System Component</TableCell>
              <TableCell style={headerStyles}>Material</TableCell>
              <TableCell style={headerStyles} align="right">
                Quantity
              </TableCell>
              <TableCell style={headerStyles} align="right">
                Unit Price $
              </TableCell>
              <TableCell style={headerStyles} align="right">
                Price $
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cartDataState?.map((item, i) => {
              let iconUrl = item?.iconURL || '/productImgs/placeholder.png';
              if (item?.price == 0) return;
              if (
                item?.name == 'Small Ice Flags' &&
                (cartData.barSystemVal == 2 || cartData.barSystemVal == 3)
              ) {
                iconUrl = urlForSmalllIce2;
                if (item?.materialName == 'Copper') iconUrl = urlForSmallIce2Copper;
              } else if (
                (item?.name == 'Large Ice Flags' || item?.name == 'Small Ice Flags') &&
                (cartData.barSystemVal == 2 || cartData.barSystemVal == 3)
              ) {
                iconUrl = urlForLargeIce2;
                if (item?.materialName == 'Copper') {
                  iconUrl = urlForLargeIce2Copper;
                }
              }
              return (
                <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell align="left">
                    <Grid display="flex" alignItems="center">
                      <img
                        style={{
                          width: 40,
                          border: '1px solid black',
                          borderRadius: 4,
                          marginRight: 8
                        }}
                        src={iconUrl}
                      />{' '}
                      {item?.name}
                    </Grid>
                  </TableCell>
                  <TableCell align="left">{item?.type}</TableCell>
                  <TableCell align="left">{item?.materialName}</TableCell>
                  <TableCell align="right">{Math.ceil(item?.quantity) || 0}</TableCell>
                  <TableCell align="right">
                    {parseFloat(item?.currentTierPrice)?.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">{parseFloat(item?.price)?.toFixed(2)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
  return (
    <>
      {cartData?.outputs?.length > 0 && (
        <>
          {systemComponentsHTML && systemComponentsHTML}
          <Text variant="body2" sx={{ mt: 2 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                fontWeight: 'bold',
                color: style.LIGHT.primary
              }}>
              <span style={{ marginRight: 5 }}>Total Price: </span>
              <span>
                {` ${
                  cartData?.unitPrice && cartData?.outputs[5]
                    ? '$' + totalPrice?.toFixed(2)
                    : 'Call'
                }`}
              </span>
            </div>
          </Text>
        </>
      )}
    </>
  );
};

FenceCartContent.propTypes = {
  cartData: PropTypes.object
};

export default FenceCartContent;
